import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Quotes, Star } from "@phosphor-icons/react";
import api from "../lib/api";

export default function Testimonials() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/testimonials").then(({ data }) => setItems(data.items || []));
  }, []);

  return (
    <section className="py-20" data-testid="testimonials">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="overline mb-3">{t("testimonials.eyebrow")}</div>
          <h2 className="font-display font-bold text-4xl md:text-5xl tracking-tight">{t("testimonials.title")}</h2>
          <div className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-amber-700">
            {[...Array(5)].map((_, i) => <Star key={i} size={16} weight="fill" />)}
            <span className="ml-1 text-ink-700 font-normal">{t("testimonials.ratingNote")}</span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((t, i) => (
            <figure key={i} className="card-soft p-6 flex flex-col" data-testid={`testimonial-${i}`}>
              <Quotes size={28} weight="fill" className="text-cobalt-200 mb-3" />
              <blockquote className="text-ink-900 leading-relaxed flex-1">"{t.quote}"</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <div className="text-2xl">{t.country}</div>
                <div>
                  <div className="font-semibold">{t.name}</div>
                  <div className="text-xs text-ink-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
